import React from "react";

export interface IncidentTestCase {
  incidentIds: string;
  symptoms: string;
  scenario: string;
  stressSetup: string;
  metrics: string;
  why: string;
}

export const IncidentDrivenTestTable: React.FC<{ incidents: IncidentTestCase[] }> = ({ incidents }) => (
  <div className="overflow-x-auto">
    <table className="min-w-full border text-xs">
      <thead className="bg-gray-100 dark:bg-gray-800">
        <tr>
          <th className="border px-2 py-1">Incident ID(s)</th>
          <th className="border px-2 py-1">Symptom(s)</th>
          <th className="border px-2 py-1">Test Scenario</th>
          <th className="border px-2 py-1">Stress/Setup</th>
          <th className="border px-2 py-1">SQL Metrics/Signals</th>
          <th className="border px-2 py-1">Why It Matters</th>
        </tr>
      </thead>
      <tbody>
        {incidents.map((row, i) => (
          <tr key={i} className="odd:bg-white even:bg-gray-50 dark:odd:bg-gray-900 dark:even:bg-gray-800">
            <td className="border px-2 py-1 whitespace-pre-line">{row.incidentIds}</td>
            <td className="border px-2 py-1 whitespace-pre-line">{row.symptoms}</td>
            <td className="border px-2 py-1 whitespace-pre-line">{row.scenario}</td>
            <td className="border px-2 py-1 whitespace-pre-line">{row.stressSetup}</td>
            <td className="border px-2 py-1 whitespace-pre-line">{row.metrics}</td>
            <td className="border px-2 py-1 whitespace-pre-line">{row.why}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
